<template>
  <svg
    class="crv-digi-klauw crv-svg-icon"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="6 5 22 22"
  >
    <path
      fill-rule="evenodd"
      d="M16.7455357,12 C17.285078,12 16.7165179,15.1405908 16.8616071,17.0390076 C17.0015004,18.8694369 17.0357143,19.8536087 17.0357143,21.6327075 C17.0357143,23.8272859 15.9491622,23.9881079 14.2104026,23.9992113 L13.6696429,23.9999348 C11.6182995,23.9999348 11,22.3214085 11,19.0077361 C11,17.4400069 11.4425197,15.6931688 12.5379464,14.3202872 C13.7578974,12.7913414 15.664702,12 16.7455357,12 Z M18.2544643,12 C19.335298,12 21.2421026,12.7913414 22.4620536,14.3202872 C23.5574803,15.6931688 24,17.4400069 24,19.0077361 C24,22.3214085 23.3817005,23.9999348 21.3303571,23.9999348 L20.7895974,23.9992113 C19.0508378,23.9881079 17.9642857,23.8272859 17.9642857,21.6327075 C17.9642857,19.8536087 17.9984996,18.8694369 18.1383929,17.0390076 C18.2834821,15.1405908 17.714922,12 18.2544643,12 Z"
    />
  </svg>
</template>

<script>
export default {
  name: 'CrvDigiKlauw',
}
</script>